<script setup lang="ts">
import type { DialogProps } from "@/components/Dialog/PictogramDialog.vue"
import Pictogram from "@/assets/pngs/Confused.png"
import PictogramDialog from "@/components/Dialog/PictogramDialog.vue"
import { DialogSize } from "@kaleidoscope-solutions/ks-design-system"

const props = withDefaults(defineProps<Omit<DialogProps, "imagePath">>(), {
  size: DialogSize.medium,
  okButton: "OK",
  cancelButton: "Cancel",
  cancelButtonColor: "violet",
  confirmDialog: false,
})

const dialogProps = { ...props, imagePath: Pictogram, okButtonColor: "violet" }
</script>

<template>
  <PictogramDialog v-bind="dialogProps" />
</template>
